<mat-card>
  <mat-card-header>
    <mat-card-title>{{meraki_switch_status.name}}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-divider></mat-divider>
    @if (meraki_switch_status.status == 'online') {
      <span id="network-health-badge-green">
        <mat-icon matTooltip="Health: good" matTooltipPosition="right">
          network_check
        </mat-icon>
      </span>
    }
    @if (meraki_switch_status.status == 'offline') {
      <span id="network-health-badge-red">
        <mat-icon matTooltip="Health: bad" matTooltipPosition="right">
          network_check
        </mat-icon>
      </span>
    }

    <a [href]="meraki_switch_status.url" target="_blank"><mat-icon matTooltip="View in Meraki Dashboard">link</mat-icon></a>
    <p><b>Status:</b> {{meraki_switch_status.status}}</p>
    <p><b>Mac:</b> {{meraki_switch_status.mac}}</p>
    <p><b>Serial:</b> {{meraki_switch_status.serial}}</p>
    <p><b>Public IP:</b> {{meraki_switch_status.publicIp}}</p>
  </mat-card-content>
</mat-card>